import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const resizeObserverErr = /ResizeObserver loop limit exceeded|ResizeObserver loop completed with undelivered notifications/;
const OriginalResizeObserver = window.ResizeObserver;
if (OriginalResizeObserver) {
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

window.addEventListener("error", (event) => {
  if (resizeObserverErr.test(event.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.onerror = (message) => {
  if (resizeObserverErr.test(String(message))) {
    return true;
  }
  return false;
};

const originalConsoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === "string" && resizeObserverErr.test(args[0])) {
    return;
  }
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
